import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    youWillBeBuying: "You'll be Buying",
    manageRecurringBuys: 'Manage Recurring Buys',
    recurringCreated: 'Recurring Buy Created',
    nextBuyOf: 'Next Buy of',
    resumingRecurringBuy: 'Resuming Recurring Buy',
    recurringBuyResumed: 'Recurring Buy Resumed',
  },
  de: {
    youWillBeBuying: 'Du wirst kaufen',
    manageRecurringBuys: 'Wiederkehrende Käufe verwalten',
    recurringCreated: 'Wiederkehrender Kauf erstellt',
    nextBuyOf: 'Nächster Kauf von',
    resumingRecurringBuy: 'Wiederkehrenden Kauf fortsetzen',
    recurringBuyResumed: 'Wiederkehrender Kauf wiederaufgenommen',
  },
});
